import { ExpandedAIAnalysis } from "./ExpandedAIAnalysis";
import { useAIDecisions } from "@app/hooks/useAIDecisions";
import { useTradingSystemPayload } from "@app/hooks/useTradingSystemPayload";

interface ExpandedAIAnalysisRowProps {
  positionId: string;
  onClose: () => void;
}

/**
 * Wrapper component for ExpandedAIAnalysis that handles data fetching.
 * This separates concerns: badge handles UI, this handles data.
 */
export function ExpandedAIAnalysisRow({
  positionId,
  onClose,
}: ExpandedAIAnalysisRowProps): JSX.Element {
  const { data: payload } = useTradingSystemPayload();
  const position = payload?.active_positions?.find((p) => p.id === positionId);
  
  // SUSTAINABLE SOLUTION: Only enable AI decisions query if position exists in active positions
  // This prevents unnecessary API calls for positions that were removed
  const positionExists = !!position;
  
  const { data, isLoading, error } = useAIDecisions(
    positionId,
    positionExists, // Only enable query if position exists
    30000
  );

  if (!position) {
    return (
      <tr>
        <td colSpan={9} className="expanded-ai-analysis-cell">
          <div className="expanded-ai-analysis">
            <div className="expanded-ai-analysis__error">Position not found</div>
          </div>
        </td>
      </tr>
    );
  }

  return (
    <ExpandedAIAnalysis
      position={position}
      data={data}
      isLoading={isLoading}
      error={error}
      onClose={onClose}
    />
  );
}

